export default __webpack_public_path__ + "static/assets/1b3bb3d38f8046cd8009cef58521125c.png";